export default __webpack_public_path__ + "static/media/h5-section2-bg2.21d2221e.png";